import {styled} from '@mui/material/styles';
import React, {FC} from 'react';
import {Typography} from '../../Typography';
import {Validation} from '../types/Validations';
import {useFileInputContext} from '../FileInputContext';
import {FileListItem} from './FileListItem';

export interface FileListProps extends React.HTMLAttributes<HTMLUListElement> {
    files?: File[];
    /**
     * List of validators. Each validator should return a boolean. Each validator will run in the order listed in the array. Passed down from FileInput
     */
    validations?: Validation[];
    /**
     * Function to remove file from list.
     */
    handleRemove?: (index: number) => void;
}

const StyledFileList = styled('ul')<FileListProps>(({theme}) => {
    return {
        width: '100%',
        maxWidth: '20rem',
        padding: 0,
        margin: `0 0 ${theme.tokens.FuelSpacing2} 0`,

        '& > .FileListItem-root:not(:last-child)': {
            marginBottom: theme.tokens.FuelSpacing2
        }
    };
});

export const FileList: FC<unknown> = () => {
    const {
        files, validations, validators, handleRemoveFiles, textMap
    } = useFileInputContext();

    const showFiles = Array.isArray(files) && files.length > 0;
    const showValidations =
        Array.isArray(validations) && validations.length > 0;

    return (
        <>
            <StyledFileList>
                {showFiles &&
                    files.map((file, index) => (
                        <FileListItem
                            checks={
                                showValidations && validations[index] ?
                                    validations[index].checks :
                                    undefined
                            }
                            className='FileInput-fileListItem'
                            key={`${index}-${file.name}`}
                            name={file.name}
                            onClose={(): void => {
                                handleRemoveFiles(index);
                            }}
                            status={
                                showValidations && validations[index] ?
                                    validations[index].status :
                                    'validating'
                            }
                            type={file.type}
                        />
                    ))}
            </StyledFileList>
            {validators.length > 0 && (
                <Typography
                    color='tertiary'
                    textAlign='center'
                    variant='caption'
                >
                    {textMap.listItemSupplement}
                </Typography>
            )}
        </>
    );
};
